<template>
	<ScheduledBreakCancelled :break-type-id="breakTypeId" />
</template>

<script>
import { REST_BREAK_ID } from "@/modules/TutorSchedule/index.js";

import ScheduledBreakCancelled from "../elements/ScheduledBreakCancelled.vue";

export default {
	components: {
		ScheduledBreakCancelled,
	},
	data() {
		return {
			breakTypeId: REST_BREAK_ID,
		};
	},
};
</script>
